"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitDeepNil = exports.omitDeepUndefined = void 0;
const lodash_1 = require("lodash");
/**
 * Return a new object with all and `undefined` values removed recursively
 */
function omitDeepUndefined(value) {
    // we can hardcast to T because the keys will be removed with undefined values, which should still conforms to T
    return omitDeep(value, [undefined]);
}
exports.omitDeepUndefined = omitDeepUndefined;
/**
 * Return a new object with all `null` and `undefined` values removed recursively
 */
function omitDeepNil(value) {
    return omitDeep(value, [undefined, null]);
}
exports.omitDeepNil = omitDeepNil;
function omitDeep(value, omittedValues) {
    if (Array.isArray(value)) {
        const newArrayValues = (0, lodash_1.map)(value, (v) => omitDeep(v, omittedValues));
        return (0, lodash_1.without)(newArrayValues, ...omittedValues);
    }
    if ((0, lodash_1.isObject)(value)) {
        const omittedValue = (0, lodash_1.mapValues)(value, (v) => omitDeep(v, omittedValues));
        return (0, lodash_1.omitBy)(omittedValue, (v) => omittedValues.includes(v));
    }
    return value;
}
//# sourceMappingURL=omit-deep.js.map